export default {"src":"/_next/static/media/GetYourScore.254ade38.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};